/** Pure expand/collapse helpers for Platform Admin sidebar groups. */

export function togglePlatformNavGroupExpanded(
  expanded: Set<string>,
  groupKey: string,
): Set<string> {
  const next = new Set(expanded)
  if (next.has(groupKey)) {
    next.delete(groupKey)
  } else {
    next.add(groupKey)
  }
  return next
}

export function isPlatformNavGroupExpanded(expanded: Set<string>, groupKey: string): boolean {
  return expanded.has(groupKey)
}

/** Best-effort active match for a child nav item (longest-prefix wins at
 * render time).
 *
 * VISTOERA_BILLING_PLAN_CREDITS_TOPUP_PAYG_REWARDS_AND_PROMOTIONS_
 * FOUNDATION_P0_V1 (task spec §17) — two Sidebar rows ("套餐与积分" /
 * "按量计费与充值") now share one route
 * (`/platform/plan-credits`) and only differ by a `?tab=...` query
 * param baked into their own `item.path`. `location.pathname` alone
 * (react-router strips the query string from it) can never distinguish
 * those two rows, so an optional `search` param (pass
 * `location.search`, e.g. `"?tab=topup-payg"`) is now checked too: an
 * `itemPath` with its own `?...` query only matches when every one of
 * ITS query params is present with the same value in the current
 * `search` (extra/unrelated current params, e.g. `&plan_key=...`, are
 * ignored — only the item's own declared params gate the match).
 * `itemPath`s with no query (the other ~30 existing rows) are
 * completely unaffected — this is purely additive. */
export function isPlatformNavItemActive(pathname: string, itemPath: string, search = ''): boolean {
  if (!itemPath) return false
  const queryIndex = itemPath.indexOf('?')
  const itemPathname = queryIndex === -1 ? itemPath : itemPath.slice(0, queryIndex)
  const itemQuery = queryIndex === -1 ? '' : itemPath.slice(queryIndex + 1)

  const pathMatches = pathname === itemPathname || pathname.startsWith(`${itemPathname}/`)
  if (!pathMatches) return false
  if (!itemQuery) return true

  const itemParams = new URLSearchParams(itemQuery)
  const currentParams = new URLSearchParams(search)
  for (const [key, value] of itemParams.entries()) {
    if (currentParams.get(key) !== value) return false
  }
  return true
}
